//settings
import React, { useRef, useEffect } from "react";

//styles
import StylesAbout from "./skills.module.scss";

//icons

import {
    FaLaravel, FaReact, FaJs, FaPhp, FaCss3Alt, FaNodeJs, FaBootstrap,
    FaAws, FaSass, FaHtml5, FaGitAlt
} from "react-icons/fa";
import { SiMysql, SiRubyonrails, SiTypescript,
    SiPostgresql, SiPostman
} from "react-icons/si";
import  { DiMongodb } from "react-icons/di";
import { TbBrandCSharp } from "react-icons/tb";

import { PiBrainFill } from "react-icons/pi";
import { FaUserTie } from "react-icons/fa";
import { GiTeamIdea } from "react-icons/gi";
import { LuBrainCircuit } from "react-icons/lu";
import { IoTimerOutline } from "react-icons/io5";
import { RiTeamLine } from "react-icons/ri";
	
const SkillsView: React.FC = () => {

    useEffect(() => {
       autoScroll();
    }, []);

    function autoScroll() {
        const scrollableDiv = document.getElementById("cards");
        if (!scrollableDiv) return;
        scrollableDiv.scrollLeft = 0;
        const scrollSpeed = 1;
        const scrollDistance = 120;
        let currentScroll = 0;
        let isScrollingForward = true;
        let completedCycle = false;
    
        const scrollStep = () => {
            if (completedCycle) return;
    
            if (isScrollingForward) {
                scrollableDiv.scrollLeft += scrollSpeed;
                currentScroll += scrollSpeed;
    
                if (currentScroll >= scrollDistance) {
                    isScrollingForward = false;
                    currentScroll = scrollDistance;
                }
            } else {
                scrollableDiv.scrollLeft -= scrollSpeed;
                currentScroll -= scrollSpeed;
    
                if (currentScroll <= 0) {
                    isScrollingForward = true;
                    currentScroll = 0;
                    completedCycle = true;
                }
            }
            if (!completedCycle) {
                requestAnimationFrame(scrollStep);
            }
        };
        scrollStep();
    }

    return (
        <>
            <div className={[StylesAbout.__main_about_me_container].join(' ')}>
                <div className={[StylesAbout.__skills_div].join(' ')}>
                    <div className={[StylesAbout.__skills].join(' ')}>
                        <div className={[StylesAbout.__main_title].join(' ')}>
                            Habilidades
                        </div>
                        <div className={[StylesAbout.__cards].join(' ')} id="cards">
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><PiBrainFill /></div>
                                <div className={[StylesAbout.__skill].join(' ')}>Rápido aprendizaje</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><FaUserTie /></div>
                                <div className={[StylesAbout.__skill].join(' ')}>Liderazgo</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><GiTeamIdea /></div>
                                <div className={[StylesAbout.__skill].join(' ')}>Facil acoplamientio</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><LuBrainCircuit /></div>
                                <div className={[StylesAbout.__skill].join(' ')}>Pensamiento crítico y analítico</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><IoTimerOutline /></div>
                                <div className={[StylesAbout.__skill].join(' ')}>Administración de tiempo</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><RiTeamLine /></div>
                                <div className={[StylesAbout.__skill].join(' ')}>Trabajo en equipo</div>
                            </div>
                        </div>
                    </div>

                    <div className={[StylesAbout.__tech].join(' ')}>
                        <div className={[StylesAbout.__title_section].join(' ')}>
                            Tecnologías
                        </div>
                        <div className={[StylesAbout.__cards].join(' ')}>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><FaReact /></div>
                                <div className={[StylesAbout.__name].join(' ')}>React y React Native</div>
                                <div className={[StylesAbout.__time].join(' ')}>2 años 4 meses</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><FaLaravel /></div>
                                <div className={[StylesAbout.__name].join(' ')}>Laravel</div>
                                <div className={[StylesAbout.__time].join(' ')}>2 años 8 meses</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><FaNodeJs /></div>
                                <div className={[StylesAbout.__name].join(' ')}>NodeJs</div>
                                <div className={[StylesAbout.__time].join(' ')}> 8 meses</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><SiRubyonrails /></div>
                                <div className={[StylesAbout.__name].join(' ')}>Ruby On Rails</div>
                                <div className={[StylesAbout.__time].join(' ')}>6 meses</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><SiTypescript /></div>
                                <div className={[StylesAbout.__name].join(' ')}>Typescript</div>
                                <div className={[StylesAbout.__time].join(' ')}>2 años 4 meses</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><FaPhp /></div>
                                <div className={[StylesAbout.__name].join(' ')}>PHP</div>
                                <div className={[StylesAbout.__time].join(' ')}>4 años</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><FaJs /></div>
                                <div className={[StylesAbout.__name].join(' ')}>JavaScript</div>
                                <div className={[StylesAbout.__time].join(' ')}>5 años</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><FaHtml5 /></div>
                                <div className={[StylesAbout.__name].join(' ')}>HTML</div>
                                <div className={[StylesAbout.__time].join(' ')}>5 años</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><FaCss3Alt /></div>
                                <div className={[StylesAbout.__name].join(' ')}>CSS</div>
                                <div className={[StylesAbout.__time].join(' ')}>5 años</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><FaBootstrap /></div>
                                <div className={[StylesAbout.__name].join(' ')}>Bootstrap</div>
                                <div className={[StylesAbout.__time].join(' ')}>3 años</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><FaSass /></div>
                                <div className={[StylesAbout.__name].join(' ')}>SCSS</div>
                                <div className={[StylesAbout.__time].join(' ')}>2 años 4 meses</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><SiMysql /></div>
                                <div className={[StylesAbout.__name].join(' ')}>MySQL</div>
                                <div className={[StylesAbout.__time].join(' ')}>4 años</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><SiPostgresql /></div>
                                <div className={[StylesAbout.__name].join(' ')}>PosgreSQL</div>
                                <div className={[StylesAbout.__time].join(' ')}>6 meses</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><DiMongodb /></div>
                                <div className={[StylesAbout.__name].join(' ')}>Mongo</div>
                                <div className={[StylesAbout.__time].join(' ')}>6 meses</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><SiPostman /></div>
                                <div className={[StylesAbout.__name].join(' ')}>Postman</div>
                                <div className={[StylesAbout.__time].join(' ')}>2 años</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><TbBrandCSharp /></div>
                                <div className={[StylesAbout.__name].join(' ')}>C#</div>
                                <div className={[StylesAbout.__time].join(' ')}>8 meses</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><FaGitAlt /></div>
                                <div className={[StylesAbout.__name].join(' ')}>Git</div>
                                <div className={[StylesAbout.__time].join(' ')}>4 años</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><FaAws /></div>
                                <div className={[StylesAbout.__name].join(' ')}>AWS</div>
                                <div className={[StylesAbout.__time].join(' ')}>2 años</div>
                            </div>
                        </div>
                    </div>

                    <div className={[StylesAbout.__message].join(' ')}>
                        <div className={[StylesAbout.__text].join(' ')}>
                            ¡Elige la tecnología de tu preferencia y vamos a crear tu aplicación ideal!
                        </div>
                    </div>

               </div>
            </div>
        </>
    );
}

export default SkillsView;